/*
 * UNIK customer club popup (F5-10, sections/unik-newsletter-popup.liquid).
 * Opens after data-delay seconds unless it was closed or used within data-days days
 * (localStorage), and waits while another dialog or drawer is open. When Shopify returns
 * from the sign-up (?customer_posted=true#<form id>), it shows the confirmation at once.
 * The script is deferred and opens nothing during load, so it does not affect LCP/CLS.
 */
(() => {
  if (customElements.get('unik-newsletter-popup')) return;

  const KEY = 'unik-newsletter-popup';

  function readDismissed() {
    try {
      return Number(window.localStorage.getItem(KEY)) || 0;
    } catch {
      return 0;
    }
  }

  function storeDismissed() {
    try {
      window.localStorage.setItem(KEY, String(Date.now()));
    } catch {}
  }

  const otherDialogOpen = (popup) =>
    Array.from(document.querySelectorAll('dialog[open]')).some((dialog) => dialog !== popup) ||
    Boolean(document.querySelector('details[open].menu-opening, cart-drawer.active, .search-modal[open], details-modal details[open]'));

  class UnikNewsletterPopup extends HTMLElement {
    connectedCallback() {
      this.dialog = this.querySelector('[data-unik-popup-dialog]');
      if (!this.dialog || this.ready) return;
      this.ready = true;
      this.querySelectorAll('[data-unik-popup-close]').forEach((button) => button.addEventListener('click', () => this.dialog.close()));
      this.querySelector('[data-unik-popup-dismiss]')?.addEventListener('click', () => this.dialog.close());
      this.dialog.addEventListener('close', storeDismissed);
      this.dialog.querySelector('form')?.addEventListener('submit', storeDismissed);
      this.dialog.addEventListener('click', (event) => {
        if (event.target !== this.dialog) return;
        const box = this.dialog.getBoundingClientRect();
        if (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom) this.dialog.close();
      });

      const params = new URLSearchParams(window.location.search);
      if (params.get('customer_posted') === 'true' && window.location.hash === `#${this.dataset.formId}`) {
        this.querySelector('[data-unik-popup-signup]').hidden = true;
        this.querySelector('[data-unik-popup-confirmation]').hidden = false;
        this.open();
        return;
      }
      if (this.dialog.querySelector('[role="alert"]')) {
        this.open(); // a failed sign-up returns with the error message
        return;
      }
      const days = Number(this.dataset.days) || 365;
      if (Date.now() - readDismissed() < days * 86400000) return;
      this.timer = window.setTimeout(() => this.openWhenFree(), (Number(this.dataset.delay) || 15) * 1000);
    }

    disconnectedCallback() {
      window.clearTimeout(this.timer);
      this.ready = false;
    }

    openWhenFree() {
      if (!this.isConnected) return;
      if (otherDialogOpen(this.dialog)) {
        this.timer = window.setTimeout(() => this.openWhenFree(), 3000);
        return;
      }
      this.open();
    }

    open() {
      if (this.dialog.open) return;
      this.dialog.showModal();
      this.dialog.querySelector('input[type="email"], [data-unik-popup-close]')?.focus();
    }
  }

  customElements.define('unik-newsletter-popup', UnikNewsletterPopup);
})();
